/* global localStorage */

import * as types from 'constants/ActionTypes.js';
import { ROOT_URL, ROOT_URL_AUTH } from 'constants/Config.js';

// import { loadProfile } from './profile'
//

import axios from 'axios';

export function inviteFormSending(data) {
  return (dispatch) => {
    dispatch({ type: types.INVITE_FORM_SENDING_START });
    return axios.post(`${ROOT_URL}`, data)
      .then((data) => {
        dispatch({ type: types.INVITE_FORM_SENDING_SUCCESS, payload: data });
      })
      .catch((error) => {
        dispatch({ type: types.INVITE_FORM_SENDING_ERROR, payload: error });
      });
  };
}

// TODO: remove
export function numberFormSending(phone) {
  return (dispatch) => {
    dispatch({ type: types.NUMBER_FORM_SENDING_START, payload: phone });
    return axios.post(`${ROOT_URL}/user/send/sms`, { phone })
      .then((data) => {
        setTimeout(() => dispatch({ type: types.NUMBER_FORM_SENDING_SUCCESS, payload: data }), 1500);
      })
      .catch((error) => {
        console.log('dispatch error: ', error.response.data.error['error-code']);
        dispatch({ type: types.NUMBER_FORM_SENDING_ERROR, payload: error.response.data.error['error-code'] });
      })
      .catch(() => {
        dispatch({ type: types.NUMBER_FORM_SENDING_ERROR, payload: 'unknown' });
      });
  };
}

// TODO: remove
export function smsFormSending(phone, code) {
  return (dispatch) => {
    dispatch({ type: types.SMS_FORM_SENDING_START });
    // const deviceId = localStorage.getItem('deviceId') || uuid() // ?
    return axios.post(`${ROOT_URL}/user/sms/login`, { phone, code, platform: 'web' })
      .then((resp) => {
        dispatch({ type: types.SMS_FORM_SENDING_SUCCESS, payload: resp.data.data });
        return resp;
      })
      .catch((error) => {
        dispatch({ type: types.SMS_FORM_SENDING_ERROR, payload: error });
      });
  };
}

export const login = (data) => ({
  type: types.SMS_FORM_SENDING_SUCCESS,
  payload: data
});

export function restoreFormSending(email) {
  return (dispatch) => {
    dispatch({ type: types.RESTORE_FORM_SENDING_START });
    return axios.post(`${ROOT_URL_AUTH}`, email)
      .then((data) => {
        dispatch({ type: types.RESTORE_FORM_SENDING_SUCCESS, payload: data });
      })
      .catch((error) => {
        dispatch({ type: types.RESTORE_FORM_SENDING_ERROR, payload: error });
      });
  };
}

export function reconnectFormSending() {
  return (dispatch) => {
    dispatch({ type: types.RECONNECT_FORM_SENDING_START });
    return axios.post(`${ROOT_URL_AUTH}`, 'data')
      .then((data) => {
        dispatch({ type: types.RECONNECT_FORM_SENDING_SUCCESS, payload: data });
      })
      .catch((error) => {
        dispatch({ type: types.RECONNECT_FORM_SENDING_ERROR, payload: error });
      });
  };
}

export function userLogout() {
  return (dispatch) => {
    dispatch({ type: types.USER_LOGOUT_START });
    return axios.post(`${ROOT_URL}/user/logout`)
      .then((data) => {
        dispatch({ type: types.USER_LOGOUT_SUCCESS, payload: data });
      })
      .catch((error) => {
        dispatch({ type: types.USER_LOGOUT_ERROR, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/loginForms.js